<template>
    <side-bar>
        <template slot="links">

            <sidebar-item :link="{ name: $t('common.monitoring'), icon: 'tim-icons icon-line-chart' }"
                v-if="monitoringAllowed">

                <!--
                <sidebar-item :link="{ name: $t('common.activity'), path: '/xlrs/monitoring/activity' }">
                </sidebar-item>
                -->

                <sidebar-item :link="{ name: $t('common.logs'), path: '/xlrs/monitoring/logs' }">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.accounts'), icon: 'tim-icons icon-multiple-19' }">

                <sidebar-item :link="{ name: $t('common.users'), path: '/xlrs/accounts/users' }"
                    v-if="$auth.hasPermission('user.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.roles'), path: '/xlrs/accounts/roles' }"
                    v-if="$auth.hasPermission('role.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.entities'), path: '/xlrs/accounts/entities' }"
                    v-if="$auth.hasPermission('entity.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.clients'), path: '/xlrs/accounts/clients' }"
                    v-if="$auth.hasPermission('client.manage')">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.data'), icon: 'tim-icons icon-database' }"
                v-if="dataAllowed">

                <sidebar-item :link="{ name: $t('xapi.common.statements'), path: '/xlrs/xapi/statements' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.activities'), path: '/xlrs/xapi/activities' }"
                    v-if="activitiesSupported">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.agents'), path: '/xlrs/xapi/agents' }"
                    v-if="agentsSupported">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.activity-profiles'), path: '/xlrs/xapi/activity-profiles' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.agent-profiles'), path: '/xlrs/xapi/agent-profiles' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.states'), path: '/xlrs/xapi/states' }">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.vocab'), icon: 'tim-icons icon-book-bookmark' }"
                v-if="vocabAllowed">

                <sidebar-item :link="{ name: $t('xapi.common.verbs'), path: '/xlrs/xapi/verbs' }"
                    v-if="verbsSupported">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.activity-types'), path: '/xlrs/xapi/activity-types' }"
                    v-if="activityTypesSupported">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.common.statement-categories'), path: '/xlrs/xapi/statement-categories' }"
                    v-if="statementCategoriesSupported">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.privacy'), icon: 'tim-icons icon-key' }"
                v-if="privacyAllowed">

                <sidebar-item :link="{ name: $t('xapi.privacy.my-statements'), path: '/xlrs/xapi/my-statements' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.privacy.my-agents'), path: '/xlrs/xapi/my-agents' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.privacy.my-profiles'), path: '/xlrs/xapi/my-profiles' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.privacy.my-states'), path: '/xlrs/xapi/my-states' }">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('xapi.privacy.my-endpoint'), path: '/xlrs/xapi/my-endpoint' }">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.settings'), icon: 'tim-icons icon-settings' }"
                v-if="$auth.hasPermission('xapi-extra.manage')">

                <sidebar-item :link="{ name: $t('common.delete-data'), path: '/xlrs/xapi/management' }">
                </sidebar-item>

            </sidebar-item>

        </template>
    </side-bar>
</template>

<script>
    export default {

        computed: {

            monitoringAllowed() {
                return this.dataAllowed
                    && this.$auth.config.xapi.logging.enabled
            },

            dataAllowed() {
                return this.$auth.hasPermission('xapi-extra.observe')
                    || this.$auth.hasPermission('xapi-extra.manage')
            },

            activitiesSupported() {
                return this.$auth.config.xapi.requests.relational || !this.$auth.config.xapi.processing.disable_activities
            },

            agentsSupported() {
                return this.$auth.config.xapi.requests.relational
            },

            vocabAllowed() {
                return this.dataAllowed && (
                    this.verbsSupported
                    || this.activityTypesSupported
                    || this.statementCategoriesSupported
                )
            },

            privacyAllowed() {
                return this.$auth.config.xapi.requests.relational
            },

            verbsSupported() {
                return this.$auth.config.xapi.requests.relational
            },

            activityTypesSupported() {
                return this.$auth.config.xapi.requests.relational && this.$auth.config.xapi.processing.record_activity_types
            },

            statementCategoriesSupported() {
                return this.$auth.config.xapi.requests.relational && this.$auth.config.xapi.processing.record_statement_categories
            },
        }
    }
</script>
